import { BaseRouteService } from 'core/services';

class PersonRouteService extends BaseRouteService {
    constructor() {
        super('persons');
    }

    find(filter) {
        return super.find(this.base + '/{?searchQuery,page,rpp,sort,embed,fields,userId,isActive}', filter);
    }

    get(id, options) {
        return super.get(this.base + '/{id}/{?embed,fields}', id, options);
    }

    getByUser(userId){
        return super.get(this.base + '/user/{userId}', {}, { userId: userId });
    }

    create(resource) {
        return super.create(this.base, resource);
    }

    update(resource) {
        return super.update(this.base + '/{id}', resource);
    }

    delete(resource) {
        return super.delete(this.base + '/{id}', resource);
    }
}

export default PersonRouteService;
